// src/pages/services/PlanningScheduling.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PlanningScheduling.module.css';

const PlanningScheduling = () => {
  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <h1 className={styles.heroTitle}>Planning and Scheduling</h1>
        <p className={styles.heroText}>
          We ensure your projects are delivered <strong>on time, on budget, and with excellence.</strong>
        </p>
        <Link to="/contact" className={styles.heroButton}>
          Book a Consultation
        </Link>
      </section>

      {/* Intro Paragraph and Services */}
      <section className={styles.serviceSection}>
        <div className={styles.contentContainer}>
          <p className={styles.introText}>
            Nulek Consulting provides a comprehensive planning and scheduling services that support projects from initiation through to project closeout. Our services ensure that clients receive clear, accurate, and defensible schedules that meet contractual, regulatory, and operational requirements.
          </p>

          <h2 className={styles.sectionTitle}>Our Planning & Scheduling Services</h2>

          <ul className={styles.serviceList}>
            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>EOI Schedule Development</h3>
              <p className={styles.serviceDesc}>
                We help organisations in the development of preliminary project timelines, identification of critical procurement and long-lead items, high-level sequencing and methodology support, risk and opportunity assessment for key delivery stages and preparation of schedule narratives and delivery strategies for bid documents.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Tender Schedule Development</h3>
              <p className={styles.serviceDesc}>
                At tender stage, we prepare detailed, realistic tender programs that reflect construction methodology, market conditions, resource requirements, and project constraints by providing detailed work breakdown structures (WBS), construction sequencing and staging logic to align with the construction methodology and as agreed with the relevant stakeholders and industry related requirements, tender compliance schedules that aligns with client requirements and external stakeholders requirements like the permits and approvals, Interface planning with services, design, approvals and procurement, duration estimates using quantities and production rates, resource loading and cost loading for cashflow generation and preparation of scenario modelling and "what-if" analysis to support pricing and resourcing decisions, inclement weather analysis and schedule risk analysis.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Contract & Baseline Schedule Development</h3>
              <p className={styles.serviceDesc}>
                We help to formalise contract program and establish a strong baseline that becomes the foundation for project control by fully resourcing and logically linking the contract schedule, preparing baseline approval documentation and schedule narrative, integration of procurement schedules, design deliverables and subcontractor inputs, alignment with contract requirements, setup of progress measurement frameworks and reporting cycles.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Construction Phase Scheduling & Project Controls</h3>
              <p className={styles.serviceDesc}>
                During delivery, we provide ongoing schedule management to ensure performance is transparent, measurable, and aligned with project objectives. Timely program updates based on contract requirements and provision of look-ahead programs, critical path analysis and early identification of delays, recovery strategies and resequencing options, earned value management (EVM) and progress dashboards using Power BI, coordination with site teams, subcontractors and consultants, executive reporting and performance forecasting.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Delay Analysis & Claims Support</h3>
              <p className={styles.serviceDesc}>
                We assist clients in demonstrating cause-and-effect relationships between events and time impacts. Forensic delay analysis (TIA, Windows, As-Planned vs As-Built), Extension of time (EOT) assessments and submissions, impact modelling for variations and disruptions, preparation of defensible supporting documentation.
              </p>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default PlanningScheduling;